import { render, staticRenderFns } from "./SingularityEmptyContainer.vue?vue&type=template&id=08b2cede&"
import script from "./SingularityEmptyContainer.vue?vue&type=script&lang=ts&"
export * from "./SingularityEmptyContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports